import { MutationTree } from 'vuex'
import { IHomeState } from './home-state.store';
import * as _ from "./home-types.store";
import { ActivityStatus } from '../../common/enums';
import { 
  IHomeMemberStatisticListingViewModel,
  IHomeTicketStatisticListingViewModel,
  IHomeBlockStatisticListingViewModel,
  IHomeContractorStatisticListingViewModel,
  IHomeServiceBookStatisticViewModel
} from '../../models/home';

export const mutations: MutationTree<IHomeState> = {
  [_.HOME_GET_LOADING]: (state: IHomeState, payload: {
    key: "memberStatistic" | "ticketStatistic",
    activityStatus: ActivityStatus
  }) => {
    state[payload.key].activityStatus = payload.activityStatus;
  }
  , [_.HOME_GET_MEMBERS]: (state: IHomeState, payload: IHomeMemberStatisticListingViewModel) => {
    state.memberStatistic.data = payload;
    state.memberStatistic.activityStatus = ActivityStatus.Loaded;
  }
  , [_.HOME_GET_TICKETS]: (state: IHomeState, payload: IHomeTicketStatisticListingViewModel) => {
    state.ticketStatistic.data = payload;
    state.ticketStatistic.activityStatus = ActivityStatus.Loaded;

  },
  [_.HOME_GET_BLOCK]: (state: IHomeState, payload: IHomeBlockStatisticListingViewModel) => {
    state.blockStatistic.data = payload;
    state.blockStatistic.activityStatus = ActivityStatus.Loaded;
  },
  [_.HOME_GET_TICKET_BY_CONTRACTOR]: (state: IHomeState, payload: IHomeContractorStatisticListingViewModel) => {
    state.contractorStatistic.data = payload;
    state.contractorStatistic.activityStatus = ActivityStatus.Loaded;

  },
  [_.HOME_GET_SERVICE_BOOK]: (state: IHomeState, payload: IHomeServiceBookStatisticViewModel) => {
    state.serviceBookStatistic.data = payload;
    state.serviceBookStatistic.activityStatus = ActivityStatus.Loaded;

  }
}


// WEBPACK FOOTER //
// ./src/store/home/home-mutations.store.ts